import {
  Component,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { map, takeUntil } from "rxjs/operators";
import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import { find, remove, clone } from "lodash";

import { Subject } from "rxjs";
import { ExerciseService } from "../../services/exercise.service";
import Exercise from "../../models/exercise.model";
import { DialogExerciseComponent } from "../dialog-exercise-content/dialog-exercise-content.component";

@Component({
  selector: "ngx-view-exercises",
  styleUrls: ["./view-exercises.component.scss"],
  templateUrl: "./view-exercises.component.html",
})
export class ViewExercisesComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() mode?: string = "home"; //home / tutor / course / detail /review / student
  @Input() courseId?: string = "";

  submitted = false;
  loading = false;
  cursor: any;
  done = false;

  display?: Exercise[] = [];
  exercises?: Exercise[] = [];

  pageSize = 3;
  strSearch = "";

  uid = "anonymous";
  subscribe: any;

  constructor(
    private exerciseService: ExerciseService,
    public userService: UserService,
    private dialogService: NbDialogService
  ) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
        } else {
          this.uid = "anonymous";
        }
        this.getExercises();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getMore(): void {
    this.pageSize = 12;
    this.getExercises();
  }

  search() {
    this.strSearch = this.strSearch.toLowerCase();
  }

  report(item) {
    //
  }

  close() {}

  //Control event lazyloading qna feedback
  onSearch(): void {
    this.strSearch = this.strSearch.toLowerCase();

    this.display = this.exercises.filter(
      function (item) {
        return (
          item.title.toLowerCase().includes(this.title) ||
          item.description.toLowerCase().includes(this.title)
        );
      },
      { title: this.strSearch }
    );
  }

  onNew() {
    let lecNew = new Exercise();
    lecNew.percentCompleted = 60;
    lecNew.privacy = false;
    this.dialogService
      .open(DialogExerciseComponent, {
        context: {
          header: "Tạo thử thách",
          mode: "new",
          exercise: lecNew,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.exercises = [value, ...this.exercises];
          this.display = [...this.exercises];
        }
      });
  }

  onEdit(item: Exercise) {
    if (item) {
      for (let i = 0; i < this.exercises.length; i++) {
        if (this.exercises[i].id == item.id) {
          this.exercises[i] = item;
          break;
        }
      }
      this.display = [...this.exercises];
    }
  }

  onDelete(value) {
    if (value) {
      remove(this.exercises, (e) => {
        return e.id == value;
      });
      this.display = [...this.exercises];
    }
  }

  private getExercises(): void {
    this.loading = true;

    let subscribe: any;
    if (this.mode == "tutor") {
      subscribe = this.exerciseService.getMyExercises(
        this.uid,
        this.pageSize,
        this.cursor
      );
    } else if (this.mode == "course" && this.courseId != "") {
      subscribe = this.exerciseService.getPublishedCourseExercises(
        this.courseId,
        this.pageSize,
        this.cursor
      );
    } else {
      subscribe = this.exerciseService.getPublishedExercises(
        this.pageSize,
        this.cursor
      );
    }

    subscribe
      .then((querySnapshot) => {
        if (querySnapshot.docs.length > 0) {
          this.cursor = querySnapshot.docs[querySnapshot.docs.length - 1];

          querySnapshot.forEach((doc) => {
            let data = new Exercise();
            data = doc.data();
            data.id = doc.id;
            data.createdOn = convertTimestamp(doc.data().createdOn);

            let item = find(this.exercises, ["id", data.id]);
            if (item) {
              item = data;
            } else {
              this.exercises.push(data);
            }
          });

          this.display = [...this.exercises];

          // console.log(
          //   `ViewExercisesComponent/${this.mode}/getExercises:`,
          //   this.display
          // );
        } else {
          this.cursor = null;
          this.done = true;
        }

        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
      });
  }
}
